import React from 'react';
export type TTimeoutKey = number | string | undefined;
export interface ITimeoutAPI {
  setTimeout: (fn: () => void | Promise<void>, timeout?: number, key?: TTimeoutKey) => void;
  clearTimeout: (key?: TTimeoutKey) => void;
  clearTimeouts: () => void;
}
export function useTimeout(): ITimeoutAPI {
  const timeouts = React.useRef<Map<TTimeoutKey, number>>(new Map<TTimeoutKey, number>());
  function clearTimeout(key?: TTimeoutKey): void {
    window.clearTimeout(timeouts.current.get(key));
    timeouts.current.delete(key);
  }
  function setTimeout(fn: () => void | Promise<void>, timeout?: number, key?: TTimeoutKey): void {
    clearTimeout(key);
    timeouts.current.set(key, window.setTimeout(() => {
      fn();
    }, timeout));
  }
  function clearTimeouts(): void {
    timeouts.current.forEach(timeout => window.clearTimeout(timeout));
    timeouts.current.clear();
  }
  React.useEffect(() => () => {
    clearTimeouts();
  }, []);
  return {
    setTimeout,
    clearTimeout,
    clearTimeouts
  };
}